import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import IdentificationCodeAlert from './identification-code-alert';
import IdentificationCodeAlertDeleteDialog from './identification-code-alert-delete-dialog';
import IdentificationCodeAlertDetail from './identification-code-alert-detail';
import IdentificationCodeAlertUpdate from './identification-code-alert-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={IdentificationCodeAlertUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={IdentificationCodeAlertUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={IdentificationCodeAlertDetail} />
      <ErrorBoundaryRoute path={match.url} component={IdentificationCodeAlert} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={IdentificationCodeAlertDeleteDialog} />
  </>
);

export default Routes;
